// Create Users Page - Corrected Version with Self-Contained Coupon Verification
import React, { useEffect, useState, useCallback } from "react";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import Constant from "../Components/Utils/Constant";
import PaymentGatewayModal from "../AffiliateDashboard/PaymentGatewayModal"; // Assuming this path is correct

// --- Helper Component for Toastify CSS ---
// In this environment, we can't import CSS files directly into JS.
// This component injects the necessary styles for react-toastify to work correctly.
const ToastifyStyles = () => (
    <style>{`
.Toastify__toast-container{z-index:9999;transform:translate3d(0, 0, 9999px);position:fixed;padding:4px;width:320px;box-sizing:border-box;color:#fff}.Toastify__toast-container--top-left{top:1em;left:1em}.Toastify__toast-container--top-center{top:1em;left:50%;transform:translateX(-50%)}.Toastify__toast-container--top-right{top:1em;right:1em}.Toastify__toast-container--bottom-left{bottom:1em;left:1em}.Toastify__toast-container--bottom-center{bottom:1em;left:50%;transform:translateX(-50%)}.Toastify__toast-container--bottom-right{bottom:1em;right:1em}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;padding:0;left:0;margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:0;transform:translateX(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:0;transform:translateX(0)}.Toastify__toast-container--rtl{right:0;left:auto}}.Toastify__toast{position:relative;min-height:64px;box-sizing:border-box;margin-bottom:1rem;padding:8px;border-radius:4px;box-shadow:0 1px 10px 0 rgba(0,0,0,.1),0 2px 15px 0 rgba(0,0,0,.05);display:flex;justify-content:space-between;max-height:800px;overflow:hidden;font-family:sans-serif;cursor:pointer;direction:ltr}.Toastify__toast--rtl{direction:rtl}.Toastify__toast-body{margin:auto 0;flex:1 1 auto;padding:6px}.Toastify__toast-icon{margin-inline-end:10px;width:20px;display:flex;align-items:center}.Toastify--animate{animation-fill-mode:both;animation-duration:.7s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.7s}@media only screen and (max-width: 480px){.Toastify__toast{margin-bottom:0;border-radius:0}}.Toastify__toast-theme--dark{background:#121212;color:#fff}.Toastify__toast-theme--light{background:#fff;color:#121212}.Toastify__toast-theme--colored.Toastify__toast--default{background:#fff;color:#000}.Toastify__toast-theme--colored.Toastify__toast--info{background:#3498db}.Toastify__toast-theme--colored.Toastify__toast--success{background:#07bc0c}.Toastify__toast-theme--colored.Toastify__toast--warning{background:#f1c40f}.Toastify__toast-theme--colored.Toastify__toast--error{background:#e74c3c}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:5px;z-index:9999;opacity:.7;transform-origin:left}.Toastify__progress-bar--rtl{left:auto;right:0;transform-origin:right}.Toastify__progress-bar-theme--light{background:#a1a1a1}.Toastify__progress-bar-theme--dark{background:#bb86fc}.Toastify__progress-bar--info{background:#3498db}.Toastify__progress-bar--success{background:#07bc0c}.Toastify__progress-bar--warning{background:#f1c40f}.Toastify__progress-bar--error{background:#e74c3c}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:hsla(0,0%,100%,.7)}.Toastify__close-button{color:#fff;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;align-self:flex-start}.Toastify__close-button--default{color:#000;opacity:.3}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}.Toastify__close-button > svg{fill:currentColor;height:16px;width:16px}.Toastify__close-button--rtl{margin-left:auto;margin-right:0}
`}</style>
);


// --- SVG Icon Components ---
const MdArrowDropDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
  </svg>
);

const RiEyeCloseLine = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/><path d="m12.3 4.3-1 .2-3.6 1.1c-1.3.4-2.5 1.2-3.4 2.2-1.3 1.5-1.9 3.4-1.6 5.3.3 2.5 1.8 4.7 3.8 6l.1.1 1.5 1 1.1.6c.7.4 1.5.6 2.3.6s1.6-.2 2.3-.6l1.1-.6 1.5-1 .1-.1c2-1.3 3.5-3.5 3.8-6 .3-1.9-.3-3.8-1.6-5.3-.9-1-2.1-1.8-3.4-2.2l-3.6-1.1-.9-.2ZM7.9 7.2l2.6-.8c.6-.2 1.2-.2 1.8 0l2.6.8c.8.2 1.6.8 2.1 1.5s.6 1.6.3 2.4c-.4 1.3-1.3 2.3-2.5 2.9l-1.3.7c-.6.3-1.3.3-1.9 0l-1.3-.7c-1.2-.6-2.1-1.6-2.5-2.9-.3-.8-.1-1.7.3-2.4.6-.7 1.3-1.3 2.1-1.5Z"/></svg>
);

const IoEye = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/><path d="M12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9Zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7Z"/></svg>
);

export default function CreateUser({ onClose, onUserCreated }) {
    // Component State
    const [isVisible, setIsVisible] = useState(true);
    const [subscriptionPlans, setSubscriptionPlans] = useState([]);
    const [isLoadingSubscriptions, setIsLoadingSubscriptions] = useState(true);
    const [subscriptionError, setSubscriptionError] = useState(null);
    const [newUser, setNewUser] = useState(null); // Will hold the created user object

    // State to manage which view to show: form or payment options
    const [paymentModalOpen, setPaymentModalOpen] = useState(false);

    // Form Fields State
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [device, setDevice] = useState('');
    const [subscription, setSubscription] = useState('');
    const [date, setDate] = useState('');
    const [address, setAddress] = useState('');
    const [proffesion, setProffesion] = useState('');
    const [gst, setGst] = useState('');
    const [companyname, setCompanyname] = useState('');
    const [createdby, setCreatedby] = useState('');
    const [usertype, setUsertype] = useState('');
    const [collectedamount, setCollectedamount] = useState(0);
    const [cuponapplied, setCuponapplied] = useState("");
    
    // UI & Validation State
    const [togglePassword, setTogglePassword] = useState(false);
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const [isGstValid, setIsGstValid] = useState(true);
    const [verifiedCoupon, setVerifiedCoupon] = useState(null);
    const [isVerifyingCoupon, setIsVerifyingCoupon] = useState(false);
    const [couponError, setCouponError] = useState('');

    // --- Fetch Subscription Plans on Mount ---
    useEffect(() => {
        const fetchSubscriptionPlans = async () => {
            setIsLoadingSubscriptions(true);
            setSubscriptionError(null);
            try {
                const response = await axios.get(`${Constant.BASE_URL}/subscription/affiliate-plans`);
                setSubscriptionPlans(response.data.subscription || []);
            } catch (err) {
                setSubscriptionError('Failed to load plans');
                console.error("Fetch error:", err);
            } finally {
                setIsLoadingSubscriptions(false);
            }
        };
        fetchSubscriptionPlans();
    }, []);

    // --- Get Creator's Name from Local Storage ---
    useEffect(() => {
        const storedName = localStorage.getItem("name");
        if (storedName) {
            setCreatedby(storedName);
        } else {
            setCreatedby("Unauthorized");
        }
    }, []);

    // --- Debounced Coupon Verification ---
    useEffect(() => {
        if (!cuponapplied) {
            setVerifiedCoupon(null);
            setCouponError('');
            setIsVerifyingCoupon(false);
            return;
        }
        setIsVerifyingCoupon(true);
        setCouponError('');
        setVerifiedCoupon(null);
        const timer = setTimeout(async () => {
            try {
                const response = await axios.post(`${Constant.BASE_URL}/cupon/verify`, {
                    cuponcode: cuponapplied
                });
                if (response.status === 200 && response.data.cupon) {
                    setVerifiedCoupon(response.data.cupon);
                    setCouponError('');
                } else {
                    setCouponError("Invalid Coupon");
                }
            } catch (error) {
                setCouponError(error.response?.data?.message || "Invalid Coupon");
                setVerifiedCoupon(null);
            } finally {
                setIsVerifyingCoupon(false);
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [cuponapplied]);

    // --- Validation & Formatting Functions ---
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const validatePhone = (phone) => /^\d{10}$/.test(phone);
    const validateGst = (gst) => {
        if (gst.trim() === "") return true;
        const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[Z]{1}\d{1}$/;
        return gstRegex.test(gst) && gst.length === 15;
    };
    const formatDate = (date) => {
        if (!date) return "";
        const [year, month, day] = date.split("-");
        return `${month}/${day}/${year}`;
    };

    // --- Price Calculation ---
    const charges = subscriptionPlans?.find(item => item.planevalidity === Number(subscription))?.price || 0;
    const cupondiscount = verifiedCoupon ? verifiedCoupon.cupondiscount : 0;
    const cgst = (9 * charges) / 100;
    const sgst = (9 * charges) / 100;
    const subTotalWithTaxes = charges + cgst + sgst;
    const sc = (2 * subTotalWithTaxes) / 100;
    const total = subTotalWithTaxes + sc;
    const cupondiscountprice = (cupondiscount * total) / 100;
    const grandtotal = total - cupondiscountprice;

    // --- Update Collected Amount ---
    useEffect(() => {
        if (subscription) {
            setCollectedamount(Math.max(0, grandtotal).toFixed(2));
        } else {
            setCollectedamount(0);
        }
    }, [subscription, grandtotal]);
    
    // --- Form Submission Handler ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        const emailIsValid = validateEmail(email);
        const phoneIsValid = validatePhone(phone);
        const gstIsValid = validateGst(gst);
        setIsEmailValid(emailIsValid);
        setIsPhoneValid(phoneIsValid);
        setIsGstValid(gstIsValid);

        if (emailIsValid && phoneIsValid && gstIsValid) {
            try {
                const userData = {
                    email, name, phone, password, device, subscription,
                    date: date ? formatDate(date) : "",
                    address, proffesion, gst,
                    collectedamount: parseFloat(collectedamount) || 0,
                    cuponapplied: verifiedCoupon ? cuponapplied : "",
                    companyname, createdby, usertype
                };
                const response = await axios.post(`${Constant.BASE_URL}/user/signup`, userData);
                if (response.status === 201) {
                    toast.success("User created! Please proceed to payment.");
                    setNewUser(userData); // Save the created user's data
                    setPaymentModalOpen(true);      // Open the payment modal view
                } else {
                    toast.error("Failed to create user.");
                }
            } catch (error) {
                toast.error(error.response?.data?.message || "An error occurred.");
                console.error("Form submission error:", error);
            }
        }
    };

    const handleClose = () => {
        setIsVisible(false);
        if (onClose) {
            onClose();
        }
    };

    return isVisible ? (
        <>
            <ToastifyStyles />
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white p-4 rounded-md shadow-lg max-h-[90vh] overflow-y-auto">
                    <div className="w-auto lg:w-[600px] xl:w-[700px] 2xl:w-[800px]">
                        <h2 className="text-lg font-semibold text-center mb-4 2xl:text-2xl">
                            Create User
                        </h2>
                        <hr className="mt-1" />

                        {!paymentModalOpen ? (
                            <form onSubmit={handleSubmit}>
                                <div className="flex flex-col md:flex-row items-start justify-center gap-x-6 py-4 text-sm 2xl:text-base">
                                    {/* Left Column */}
                                    <div className="w-full md:w-1/2 space-y-4">
                                        <div className="flex items-center">
                                            <label htmlFor="name" className="w-1/3 text-right pr-4">
                                                Name :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <input type="text" id="name" className="w-2/3 border-b border-gray-500 outline-none p-1" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} required />
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="usertype" className="w-1/3 text-right pr-4">
                                                User Type :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="w-2/3 relative">
                                                <select id="usertype" className="w-full border-b border-gray-500 appearance-none outline-none bg-white p-1" value={usertype} onChange={(e) => setUsertype(e.target.value)} required>
                                                    <option value="" disabled>Select Type</option>
                                                    <option value="Demo">Demo</option>
                                                    <option value="Sales">Sales</option>
                                                </select>
                                                <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"><MdArrowDropDown /></span>
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="phone" className="w-1/3 text-right pr-4">
                                                Phone :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="w-2/3 flex flex-col">
                                                <input type="text" id="phone" className="w-full border-b border-gray-500 outline-none p-1" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" required />
                                                {!isPhoneValid && (<p className="text-red-500 text-xs mt-1">Invalid phone format (10 digits)</p>)}
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="email" className="w-1/3 text-right pr-4">
                                                Email :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="w-2/3 flex flex-col">
                                                <input type="email" id="email" className="w-full border-b border-gray-500 outline-none p-1" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                                {!isEmailValid && (<p className="text-red-500 text-xs mt-1">Invalid email format</p>)}
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="password" className="w-1/3 text-right pr-4">
                                                Password :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="w-2/3 relative">
                                                <input type={togglePassword ? "text" : "password"} id="password" className="w-full border-b border-gray-500 outline-none p-1" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                                <span onClick={() => setTogglePassword(!togglePassword)} className="absolute inset-y-0 right-0 flex items-center cursor-pointer pr-2">
                                                    {togglePassword ? <IoEye /> : <RiEyeCloseLine />}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="device" className="w-1/3 text-right pr-4">
                                                Device :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="w-2/3 relative">
                                                <select id="device" className="w-full border-b border-gray-500 appearance-none outline-none bg-white p-1" value={device} onChange={(e) => setDevice(e.target.value)} required>
                                                    <option value="" disabled>Select Device</option>
                                                    <option value="Android">Android</option>
                                                    <option value="IOS">IOS</option>
                                                </select>
                                                <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"><MdArrowDropDown /></span>
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="subscription" className="w-1/3 text-right pr-4">
                                                Subscription :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="w-2/3 relative">
                                                <select id="subscription" className="w-full border-b border-gray-500 appearance-none outline-none bg-white p-1" value={subscription} onChange={(e) => setSubscription(e.target.value)} required>
                                                    {isLoadingSubscriptions ? ( <option value="" disabled>Loading...</option>
                                                    ) : subscriptionError ? (<option value="" disabled>{subscriptionError}</option>
                                                    ) : (
                                                        <>
                                                            <option value="" disabled>Select Subscription</option>
                                                            {subscriptionPlans.map((plan, index) => (
                                                                <option key={index} value={plan.planevalidity}>{plan.planname}</option>
                                                            ))}
                                                        </>
                                                    )}
                                                </select>
                                                <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"><MdArrowDropDown /></span>
                                            </div>
                                        </div>
                                        <div className="flex py-3 justify-end">
                                            {subscription && (
                                                <div className=" text-gray-600 italic">
                                                    Subscription Charges: {charges}<br />
                                                    CGST (9%): {cgst}<br />
                                                    SGST (9%): {sgst}<br />
                                                    Service Charges (2%): {sc}<br />
                                                    <hr className="fw-bolder" />
                                                    Total: {total};<br />
                                                    {cuponapplied && (
                                                        <div>
                                                            Coupon Discount: {cupondiscount || 0}% ;
                                                            <hr className="fw-bolder" />
                                                            {isNaN(grandtotal) ? (
                                                                <p>Total: {total}</p>
                                                            ) : (
                                                                <p>Grand Total: {grandtotal}</p>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    
                                    {/* Right Column */}
                                    <div className="w-full md:w-1/2 space-y-4 mt-4 md:mt-0 md:border-l md:pl-6">
                                        <div className="flex items-center">
                                            <label htmlFor="yourDateInput" className="w-1/3 text-right pr-4">Date of Birth:</label>
                                            <input type="date" id="yourDateInput" className="w-2/3 border-b border-gray-500 outline-none p-1" value={date} onChange={(e) => setDate(e.target.value)} />
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="address" className="w-1/3 text-right pr-4">Address :</label>
                                            <input type="text" id="address" className="w-2/3 border-b border-gray-500 outline-none p-1" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Address" />
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="proffesion" className="w-1/3 text-right pr-4">
                                                Profession :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="w-2/3 relative">
                                                <select id="proffesion" className="w-full border-b border-gray-500 appearance-none outline-none bg-white p-1" value={proffesion} onChange={(e) => setProffesion(e.target.value)} required>
                                                    <option value="" disabled>Select Profession</option>
                                                    <option value="Fabric Manufacturer">Fabric Manufacturer</option>
                                                    <option value="Garment Manufacturer">Garment Manufacturer</option>
                                                    <option value="Yarn Manufacturer">Yarn Manufacturer</option>
                                                    <option value="Trader & Broker">Trader & Broker</option>
                                                    <option value="Buyer">Buyer</option>
                                                    <option value="Designer">Designer</option>
                                                    <option value="Finisher">Finisher</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"><MdArrowDropDown /></span>
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="gst" className="w-1/3 text-right pr-4">GST Number :</label>
                                            <div className="w-2/3 flex flex-col">
                                                <input type="text" id="gst" className={`w-full border-b border-gray-500 outline-none p-1 ${gst.length > 0 && !isGstValid ? "border-red-500" : ""}`} value={gst} onChange={(e) => setGst(e.target.value)} placeholder="GST Number" />
                                                {gst.length > 0 && !isGstValid && (<p className="text-red-500 text-xs mt-1">Invalid GST number</p>)}
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="companyname" className="w-1/3 text-right pr-4">Company Name:</label>
                                            <input type="text" id="companyname" className="w-2/3 border-b border-gray-500 outline-none p-1" value={companyname} onChange={(e) => setCompanyname(e.target.value)} placeholder="Company Name" />
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="createdby" className="w-1/3 text-right pr-4">Created By :</label>
                                            <input type="text" id="createdby" className="w-2/3 border-b border-gray-500 outline-none p-1 bg-gray-100" value={createdby} readOnly />
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="cuponapplied" className="w-1/3 text-right pr-4">Coupon :</label>
                                            <div className="w-2/3 relative">
                                                <input id="cuponapplied" className="w-full border-b border-gray-500 appearance-none outline-none p-1" value={cuponapplied} placeholder="Enter Coupon Code" onChange={(e) => setCuponapplied(e.target.value)} />
                                                <div className="h-4 mt-1 text-xs">
                                                    {isVerifyingCoupon && <p className="text-blue-500">Verifying...</p>}
                                                    {couponError && <p className="text-red-500">{couponError}</p>}
                                                    {verifiedCoupon && <p className="text-green-600 font-semibold">Coupon Applied! ({verifiedCoupon.cupondiscount}% off)</p>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <label htmlFor="collectedamount" className="w-1/3 text-right pr-4 font-semibold">Total Amount:</label>
                                            <input type="number" id="collectedamount" className="w-2/3 border-b border-gray-500 outline-none p-1 bg-gray-100 font-bold" value={collectedamount} readOnly />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex justify-center pt-6 space-x-12">
                                    <button type="button" onClick={handleClose} className="bg-gray-200 px-6 py-2 flex-shrink-0 shadow-md rounded-md hover:bg-gray-300 transition">
                                        Cancel
                                    </button>
                                    <button type="submit" className="px-6 py-2 flex-shrink-0 rounded-md text-white font-semibold hover:opacity-90 transition" style={{ background: "linear-gradient(90deg, #FF9C28, #FFD6A6)" }}>
                                        Proceed to Payment
                                    </button>
                                </div>
                            </form>
                        ) : null }
                        
                        {/* Conditionally render the payment modal */}
                        {paymentModalOpen && (
                            <PaymentGatewayModal
                                user={newUser}
                                subscriptionAmount={collectedamount}
                                selectedSubscription={subscription}
                                onClose={() => {
                                    setPaymentModalOpen(false); // Close payment modal
                                    if (onClose) onClose();      // Close the main create user component
                                    if (onUserCreated) onUserCreated(); // Refresh user list in the dashboard
                                }}
                            />
                        )}

                    </div>
                </div>
            </div>
        </>
    ) : null;
}